import Layout from '@modules/layout/components/layout.vue';

export default [{
        name: '',
        path: '',
        component: Layout,
        meta: {
                auth: true
        },
        children: [
        ],
}];